/**
 * App version tracking for cache busting on deploy.
 *
 * When the backend is updated, the x-app-version header will change.
 * We detect this and reload on the next navigation.
 */

let initialVersion: string | null = null
let isStale = false

export function checkVersion(response: Response): void {
  const version = response.headers.get('x-app-version')
  if (!version) return

  if (initialVersion === null) {
    // First API response - store the version
    initialVersion = version
  } else if (version !== initialVersion) {
    // Version changed - app is stale
    isStale = true
  }
}

export function isAppStale(): boolean {
  return isStale
}

export function reloadIfStale(): void {
  if (isStale && typeof window !== 'undefined') {
    window.location.reload()
  }
}

// Install global fetch interceptor for /api/ calls (client-side only)
if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const originalFetch = window.fetch
  window.fetch = async function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const response = await originalFetch(input, init)

    // Check version for API calls
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
    if (url.startsWith('/api/')) {
      checkVersion(response)
    }

    return response
  }
}
